import React from 'react'
import wheel from "../../assets/images/wheel.png";
import saving from "../../assets/images/saving.png";
import test from "../../assets/images/test.png";
import international from "../../assets/images/international.png";
import gift from "../../assets/images/gift.png";
import time from "../../assets/images/time.png";
import { Routers } from "./../../routes/Constant";
import { Link } from 'react-router-dom';


const QuickLinks = ({ heading, cardContent }) => {
  return (
    <section className="keyzi-quickLink--wrapper keyzi_content--wrapper ">
      <div className="container">
        <div className="keyzi-quickLink--inner">
          <div className="row">
            {cardContent?.map((e)=>{
              return(
                <div className="col-lg-4 col-md-6">
              <div className="quick-link-card wheel">
                <img src={`https://keyzi.com.au/keyzi-admin/public${e.image}`}   alt={e.image_attribute} className='img-fluid' />
                <h5>{e.title}</h5>
                <Link to={e.btn_link} className='btn'>{e.btn_text}</Link>
              </div>
            </div>
              )
            })}
            {/* <div className="col-lg-4 col-md-6">
              <div className="quick-link-card wheel">
                <img src={wheel} alt="image" className='img-fluid' />
                <h5>Driving Lessons</h5>
                <Link to={Routers.drivinglessonsnew} className='btn'>Book Now</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="quick-link-card saving">
                <img src={saving} alt="image" className='img-fluid' />
                <h5>Become An Instructor</h5>
                <Link to={Routers.becomeAInstructor} className='btn'>Apply Now</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="quick-link-card test">
                <img src={test} alt="image" className='img-fluid' />
                <h5>Tests & Packages</h5>
                <Link to={Routers.testPackagesnew} className='btn'>Book Now</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="quick-link-card international">
                <img src={international} alt="image" className='img-fluid' />
                <h5>International Conversions</h5>
                <Link to={Routers.internationalsConversions} className='btn'>Learn More</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="quick-link-card gift">
                <img src={gift} alt="image" className='img-fluid' />
                <h5>Gift Vouchers</h5>
                <Link to={Routers.giftvoucher} className='btn'>Buy Voucher</Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="quick-link-card time">
                <img src={time} alt="image" className='img-fluid' />
                <h5>Refresher Courses</h5>
                <Link to={Routers.refresherCourses} className='btn'>Schedule</Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  )
}

export default QuickLinks